import React from 'react'
import { 
  CRow, 
  CCol, 
  CButton,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInputGroupAppend
 } from '@coreui/react'


const InputWrap = props => {
  const {
    name,
    text,
    ...rest
  } = props
  
  return (
    <CCol sm={props.size}>
      <CInputGroup className={"form-group " + (props.className?props.className:"")}>
        {props.prepend && 
        <CInputGroupPrepend>
          <CInputGroupText>
            <span className={props.required && "required"}>{props.prepend}</span>
          </CInputGroupText>
        </CInputGroupPrepend>}
        {props.children}
        {props.append && 
        <CInputGroupAppend>
            {props.append}
        </CInputGroupAppend>}
      </CInputGroup>
    </CCol>
  )
}


const BoxTitle = props => {
  const {
    name,
    text,
    ...rest
  } = props
  
  return (
    <div className={"box-title col-"+(props.size?props.size:"12")}><span>■ {props.title}</span></div>
  )
}

const getColSize = (child) =>{
  let size = 0;
  if(child.props && child.props.size){
    size = Number(child.props.size);
  }
  return size;
}

const getTotColSize = (children) =>{
  let size = 0;
  if(Array.isArray(children)){
    children.forEach(child => {
      size += getColSize(child);
    });
  } else {
    size += getColSize(children);
  }
  return size;
}

const SearchBox = props => {
  let {
    name,
    text,
    size,
    ...rest
  } = props

  size = (size == null || size == "") ? 12 - (getTotColSize(props.children) % 12) : size;

  const onSearchClick = () => {
    props.onSearchClick();
  }

  return (
    <CRow className="search-box">
      {props.children}
      <InputWrap size={size} className="form-group input-group text-right display-block">
        <CButton size="sm" color="info" id="search" onClick={onSearchClick}>조회</CButton>
      </InputWrap>
    </CRow>
  )
}


const ExtraBox = props => {
  const {
    name,
    text,
    ...rest
  } = props

  return (
    <CRow className="extra-box">
      <CCol size="12" className="text-right">
        {props.children}
      </CCol>
    </CRow>
  )
}

const BodyBox = props => {
  const {
    name,
    text,
    ...rest
  } = props

  return (
    <CRow className="body-box">
      <CCol size="12">
        {props.children}
      </CCol>
    </CRow>
  )
}


// export default React.memo(SearchBox)
export {SearchBox, ExtraBox, BodyBox, InputWrap, BoxTitle}